import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogRef,
} from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { UserSettingsModels } from '@share-models';
import { UserSettingsActions } from '../../data-access/state/user-account-settings.actions';
import {
  EnableEscCloseDirective,
  UiButtonComponent,
  UiToggleComponent,
} from '@ui';
import { Store } from '@ngrx/store';
import { UserAccountSettingsState } from '../../data-access/state/user-account-settings.reducer';

@Component({
  selector: 'app-global-search-settings-modal',
  standalone: true,
  imports: [
    TranslatePipe,
    MatDialogClose,
    UiButtonComponent,
    UiToggleComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './global-search-settings-modal.component.html',
  styleUrl: './global-search-settings-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [EnableEscCloseDirective],
})
export class GlobalSearchSettingsModalComponent implements OnInit {
  private fb = inject(FormBuilder);
  private dialogRef = inject(MatDialogRef<GlobalSearchSettingsModalComponent>);
  private store$ = inject<Store<UserAccountSettingsState>>(Store);
  public data = inject<{
    globalSearchSettings: UserSettingsModels.GlobalSearchSettingsModel;
  }>(MAT_DIALOG_DATA);

  public settingsForm = this.fb.nonNullable.group({
    markResult: [true, [Validators.required.bind(Validators)]],
    includeAllMatch: [true, [Validators.required.bind(Validators)]],
  });

  public ngOnInit(): void {
    if (this.data.globalSearchSettings) {
      this.settingsForm.patchValue(this.data.globalSearchSettings);
    }
  }

  public save(): void {
    const formValue = this.settingsForm.getRawValue();
    const globalSearchSettings: UserSettingsModels.GlobalSearchSettingsModel = {
      markResult: !!formValue.markResult,
      includeAllMatch: !!formValue.includeAllMatch,
    };
    this.store$.dispatch(
      UserSettingsActions.startUpdateGlobalSearchSettings({
        globalSearchSettings: globalSearchSettings,
      }),
    );
    this.dialogRef.close(globalSearchSettings);
  }

  public close(): void {
    this.dialogRef.close();
  }
}
